import Vue from 'vue'
import store from '@/store'
import Axios from 'axios'
import { Message } from 'element-ui';

// 获取AK，请求头加入AK
const AK = store.state.AK
if (AK) {
    Axios.defaults.headers.AK = AK;
}

const service = Axios.create()
// const CancelToken = axios.CancelToken;
// Axios.CancelToken = CancelToken;
/* let url;
process.env.NODE_ENV === 'development' ? url = 'http://192.168.1.125:10031' : url = '/api' ;
Axios.defaults.baseURL = url; */

service.interceptors.response.use(
    async (response) => {
        const state = response.data.state;
        if (state === 1000) {
            await store.dispatch("user/resetAll");
            const href = window.location.href
            window.location.href = `/login?redirect=${href}`;
        } else if (state === 0) {
            Message({
                message: response.data.mes,
                type: "error"
            })
        }
        return response;
    },
    error => {
        // console.log('err' + error) // for debug
        if (!Axios.isCancel(error)) {
            // 处理错误
            Message({
                message: error,
                type: "error",
                duration: 5 * 1000
            })
        }
        /* Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        }) */
        return Promise.reject(error)
    })

Vue.prototype.$axios = service;